<script setup>
  import ComponentCard from "@components/Cards/Card.vue";
  import ComponentIcon from "@components/Icons/Icon.vue";
  import {MedButton} from "@pharma4u/medicheck-components";

  // TODO Naming?
  defineOptions({name: "ComponentBmpImportDialogRequestedPage"});

  defineProps({
    requestedPage: {
      type: String,
      default: null,
    },
  });

  defineEmits(["skip"]);
</script>

<template>
  <ComponentCard v-if="requestedPage" :test-id="getTestId('upload-tab')">
    <div class="flex items-start space-x-2">
      <ComponentIcon class="text-xl text-mcred">warning_amber</ComponentIcon>

      <div>
        <p>{{ requestedPage }}</p>
        <p class="mt-2 text-gray-500">
          Wenn Ihnen nicht alle Seiten des BMP vorliegen, können Sie mit den bisher eingelesenen (unvollständigen) Daten
          trotzdem fortfahren.
        </p>
      </div>
    </div>

    <div class="flex w-full flex-row-reverse">
      <MedButton :data-test="getTestId('skip-requested-page-button')" @click="$emit('skip')">
        Fehlende Seiten auslassen
      </MedButton>
    </div>
  </ComponentCard>
</template>
